module.exports = __webpack_public_path__ + "img/EN ISO 374-5 Virus.b7980103.png";